import { render, staticRenderFns } from "./DetalhesGerenciamentoServico.vue?vue&type=template&id=7ed77c96&scoped=true"
import script from "./DetalhesGerenciamentoServico.vue?vue&type=script&lang=js"
export * from "./DetalhesGerenciamentoServico.vue?vue&type=script&lang=js"
import style0 from "./DetalhesGerenciamentoServico.vue?vue&type=style&index=0&id=7ed77c96&prod&lang=css"
import style1 from "./DetalhesGerenciamentoServico.vue?vue&type=style&index=1&id=7ed77c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed77c96",
  null
  
)

export default component.exports